import types from '@/models';
import http from './dnaApiConfig';

const adminConfig = {
  headers: {
    "Authorization": `Token ${process.env.VUE_APP_DNA_ADMIN_API_KEY}`
  }
}

export default {

  /**
   * Returns the response from the api
   * @returns {Array} list of [TraitScoreItem]. [] if none.
   */
  async fetchTraitScoreDetails () {
    try {

      let response = await http.get(`/v1/traits/traitsandscoreslist`, http.getDefaultConfig());
      if (response.status && response.status !== 200) {
        return [];
      }

      return response.data.map((it)=>{
        return new types.DnaTraitScoreDetail(it);
      });

    } catch (e) {
      return []
    }

  },

  /**
   *
   * @param userId
   * @return {Promise<FullDnaKit|null>}
   */
  async getKitByUserId(userId) {
    try {

      let response = await http.get(`/v1/kits/byuser/${userId}/full`, http.getDefaultConfig());
      if (response.status !== 200 || !response.data) {
        return null;
      }

      return new types.FullDnaKit(response.data);

    } catch (e) {
      return null;
    }

  },

  /**
   * @param oldUserId
   * @returns {Promise<null|[DnaOldKit]>}
   */
  async getKitOldKits(oldUserId) {
    try {

      let response = await http.get(`/v1/kits/old-kits/${oldUserId}`, http.getDefaultConfig());
      if (response.status !== 200 || !response.data) {
        return [];
      }

      return response.data.map((kit) => {
        return new types.DnaOldKit({
          kitId: kit.kitId,
          status: kit.status,
          statusAt: kit.statusDate
        });
      });
    } catch (e) {
      return [];
    }
  },

  /**
   * @param kitId
   * @return {Promise<GGKit|null>}
   */
  async getGGKit(kitId) {
    try {

      let response = await http.get(`/v1/gd/get-kit/${kitId}`, http.getDefaultConfig());
      if (response.status !== 200) {
        return null;
      }

      return new types.GGKit(response.data);

    } catch (e) {
      return null;
    }

  },

  /**
   *
   * @param reportId
   * @return {Promise<GeneticReport|null>}
   */
  async getGeneticReport(reportId) {
    try {

      let response = await http.get(`/v1/gd/get-genetic-report/${reportId}`, http.getDefaultConfig());

      if (response.status !== 200) {
        return null;
      }

      return new types.GeneticReport(response.data);

    } catch (e) {
      return null;
    }

  },

  /**
   *
   * @param kitId
   * @return {Promise<null|PurchasedKits>}
   */
  async getPurchasedKits(kitId) {
    try {

      let response = await http.get(`/v1/purchased/kits/${kitId}`, http.getDefaultConfig());
      if (response.status !== 200) {
        return null;
      }

      return new types.PurchasedKits(response.data);

    } catch (e) {
      return null;
    }

  },

  /**
   *
   * @param searchValue
   * @returns {Promise<null|Array<{}>>}
   */
  async getPurchasedKitsBySearch(searchValue) {
    try {
      let response = await http.get(`/v1/purchased/kits-by-search/${searchValue}`, http.getDefaultConfig());
      if (response.status !== 200) {
        return null;
      }

      return response.data;

    } catch (e) {
      return null;
    }

  },

  /**
   *
   * @param personId
   * @return {Promise<null|[DnaOldKit]>}
   */
  async getGdKits(personId) {
    try {
      let response = await http.get(`/v1/gd/get-person/${personId}`, http.getDefaultConfig());
      if (response.status !== 200 || !response.data.dnaKits || !response.data.dnaKits.length) {
        return [];
      }

      return response.data.dnaKits.map((kit) => {
        return new types.DnaOldKit(kit);
      });
    } catch (e) {
      return [];
    }
  },

  async getKitByKitId(kitId) {
    try {
      let response = await http.get(`/v1/kits/${kitId}/full`, http.getDefaultConfig());
      if (response.status !== 200) return null;
      return new types.FullDnaKit(response.data);
    } catch (e) {
      return null;
    }
  },

  async createDnaOrder(order) {
    try {
      const response = await http.post('/admin/order-dna-kit', order, adminConfig);
      if (response.status !== 201 || !response.data.order) return {serverError: "Internal server error!"};
      return new types.DnaOrder(response.data.order);

    } catch (e) {
      if (e.response.status === 422) return e.response.data;
      return {serverError: e.response.data.errors};
    }
  },

  async archiveKit(kitId, userId) {
    try {

      const response = await http.delete('/admin/archive-kit', { data: { kitId: kitId, userId: userId }, ...adminConfig });
      if (response.status !== 200) return null;
      return response.data;

    } catch (e) {
      return null;
    }
  }
}
